export default __webpack_public_path__ + "static/media/letalk-logo-white.e92df79b.svg";